const NotFound: React.FC = () => {
  return <h1>Not Found</h1>;
};

export default NotFound;
